import {
  Directive,
  effect,
  inject,
  input,
  signal,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { FeatureFlagService } from '@core/services/feature-flag/feature-flag.service';
import { FeatureFlagsEnum } from '@generated/featureFlags.enum';

@Directive({
  selector: '[featureFlag]',
  standalone: true,
})
export class FeatureFlagDirective {
  viewContainerRef = inject(ViewContainerRef);
  templateRef = inject(TemplateRef);
  featureFlagService = inject(FeatureFlagService);

  flags = input.required<`${FeatureFlagsEnum}`[] | FeatureFlagsEnum[]>({ alias: 'featureFlag' });

  private hasView = signal(false);

  constructor() {
    effect(() => {
      this.featureFlagService.featureFlags();
      const flagsToCheck = this.flags();

      const features = flagsToCheck.map((flag) =>
        this.featureFlagService.featureFlagMap.get(flag as FeatureFlagsEnum),
      );

      const allEnabled = features.every((feature) => feature?.active);

      if (allEnabled && !this.hasView()) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
        this.hasView.set(true);
      } else if (!allEnabled && this.hasView()) {
        this.viewContainerRef.clear();
        this.hasView.set(false);
      }
    });
  }
}
